var map = {
	"./2Top.svg": 8892,
	"./brand.svg": 4194,
	"./drag.svg": 1345,
	"./email.svg": 2533,
	"./font.svg": 832,
	"./light.svg": 6717,
	"./lightning.svg": 4223,
	"./logo.svg": 5318,
	"./park.svg": 1459,
	"./phone.svg": 861,
	"./print.svg": 9832,
	"./qq.svg": 21,
	"./round.svg": 1097,
	"./sign.svg": 8852,
	"./store.svg": 8442,
	"./web.svg": 3659,
	"./weixin.svg": 4421
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6869;